import gql from "graphql-tag";

export default {
  update: gql`
    mutation UpdateI18nCell ($input: I18nFieldsInput!) {
      i18nCell (input: $input) {
        language_code
        text
        text_data
        image_uri
        video_uri
        button_background_image_uri
        background_image_uri
        background_video_uri
        name
        button_download_text
        button_retake_text
        button_take_text
        send_text
        sent_text
        look_text
        description_text
        conditions1_text
        conditions2_text
        send_by_email_text
        print_text
        printed_text
        email_subject
        email_body
      }
    }`,
}
